import { useState, useCallback } from "react";
import { defineMessages } from "react-intl";

import withFormStore, { useForm } from "../../Form/withFormStore";
import { useFormatMessage } from "../../Intl/Context";
import { useAlert } from "../../Alerts/withAlert";
import { ALERT_TYPE_ERROR } from "../../Alerts/Alert";
import StringField from "../../Form/Field/StringField";
import Button from "../../Buttons/Button";

const AuthenticationTwoFactorPhoneNumberForm = ({
  submitPhoneNumber,
  onNumberValidated,
  helpMessage
}) => {
  const { showAlert } = useAlert();
  const { formState, validateForm } = useForm();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const t = useFormatMessage();
  const phoneLabel = t(intlMessages.phone);
  const submitLabel = t(intlMessages.submit);

  const handleSubmit = useCallback(
    async e => {
      e.preventDefault();
      e.stopPropagation();

      if (isSubmitting || !validateForm()) return;

      setIsSubmitting(true);

      try {
        const result = await submitPhoneNumber(formState);
        setIsSubmitting(false);

        if (result.success) {
          onNumberValidated();
        } else {
          showAlert({ message: result.notice, type: ALERT_TYPE_ERROR });
        }
      } catch (error) {
        setIsSubmitting(false);
        showAlert({ message: error.message, type: ALERT_TYPE_ERROR });
      }
    },
    [
      formState,
      validateForm,
      isSubmitting,
      onNumberValidated,
      showAlert,
      submitPhoneNumber
    ]
  );

  return (
    <form
      onSubmit={handleSubmit}
      className="box padding-md"
      data-phone-number-change-enrollment-form
    >
      <p className="margin-bottom-sm text-small">{helpMessage}</p>

      <StringField
        fieldName="phone"
        required
        label={phoneLabel}
        type="tel"
        autoComplete="tel"
      />

      <Button
        type="submit"
        className="btn btn-primary btn-block-md margin-top-sm"
        onClick={handleSubmit}
        disabled={isSubmitting}
        data-loading={isSubmitting}
        label={submitLabel}
      />
    </form>
  );
};

export default withFormStore(AuthenticationTwoFactorPhoneNumberForm);

const intlMessages = defineMessages({
  phone: {
    id: "twoFactor.phoneNumber.change.phone",
    defaultMessage: "Numéro de mobile"
  },
  submit: {
    id: "twoFactor.phoneNumber.change.submit",
    defaultMessage: "Envoyer le code"
  }
});
